module.exports = new __parcel__URL__("list-merge-modal-multi-project-light.9f0658d5.png").toString();